import React from "react";
import { capitalize, capitalizeEachWord, formatDate } from "../../../Common/CommonFunction";
import { educationLevelsOptions, performanceScaleOptions, schoolMediumsOptions, JOBSEEKER_PROFILE_IMAGE } from "../../../../Constant";
import github from "../../../../assets/images/resumeIcons/githubwhite.png";
import linkedin from "../../../../assets/images/resumeIcons/linkedinwhite.png";
import callwhite from "../../../../assets/images/resumeIcons/callwhite.png";
import emailwhite from "../../../../assets/images/resumeIcons/emailwhite.png";
import locationwhite from "../../../../assets/images/resumeIcons/locationwhite.png";
import star_blank from "../../../../assets/images/star/star_blank.png"
import star_half from "../../../../assets/images/star/star_half.png"
import star from "../../../../assets/images/star/star.png"
const ResumeTemplate4 = ({ jobseekerData = {} }) => {
  const {
    jobseeker_full_name = "",
    jobseeker_preferred_job_title = "",
    jobseeker_email1 = "",
    jobseeker_phone1 = "",
    country_code1 = "",
    online_detail_result = [],
    work_experience = [],
    education = [],
    it_skills = [],
    resume_headline = "",
    work_sample = [],
    jobseeker_photo = "",
    jobseeker_location = {},
    primary_skill = []
  } = jobseekerData;

  const renderSocialIcon = (socialProfileName) => {
    switch (socialProfileName.toUpperCase()) {
      case "LINKEDIN":
        return <img className="contact-icon" src={linkedin} alt="LinkedIn Icon" />;
      case "GITHUB":
        return <img className="contact-icon" src={github} alt="GitHub Icon" />;
      default:
        return null;
    }
  };

  return (
    <div id="resume4">
      <div className="resume4">
        <header>
          <a href="#" target="_blank"><img

            src="/job/naukrify_poweredby.png"
            // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
            alt="User profile picture"
            className="img-fluid"
          /></a>
        </header>
        <div className="container-4">
          <div className="left">

            {jobseeker_photo && (
              <>
                <div className="profile-square"></div>
                <div className="img-container-4">
                  <img
                    src={jobseeker_photo}
                    alt="Profile Picture"
                    className="profile-pic"
                  />
                </div>
              </>
            )}
            {(jobseeker_full_name || jobseeker_preferred_job_title) && (
              <div className="name-prf">
                {jobseeker_full_name && <h2>{jobseeker_full_name}</h2>}
                {jobseeker_preferred_job_title && <p>{jobseeker_preferred_job_title}</p>}
              </div>
            )}
            <div className="basic-info">
              <div className="contact">
                <div className="section-title">CONTACT</div>
                <div class="after-underline"></div>
                <table>
                  <tbody>
                    {jobseeker_email1 && (
                      <tr className="email">
                        <td>
                          <img src={emailwhite} alt="email icon" />
                        </td>
                        <td>
                          <a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a>
                        </td>
                      </tr>
                    )}
                    {jobseeker_phone1 && (
                      <tr className="mobile">
                        <td>
                          <img src={callwhite} alt="call icon" />
                        </td>
                        <td>
                          <a href={`tel:${country_code1}${jobseeker_phone1}`}>{country_code1}{jobseeker_phone1}</a>
                        </td>
                      </tr>
                    )}
                    {jobseeker_location.label && (
                      <tr className="address">
                        <td>
                          <img src={locationwhite} alt="location icon" />
                        </td>
                        <td>{jobseeker_location.label}</td>
                      </tr>
                    )}
                    {online_detail_result.map((profile, index) => (
                      (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                        profile.social_profile_name.toUpperCase() === "GITHUB") && (
                        <tr className="address" key={index}>

                          <td> {renderSocialIcon(profile.social_profile_name)}</td>
                          <td> <a href={profile.url} target="_blank" rel="noopener noreferrer">
                            {profile.url}
                          </a></td>

                        </tr>
                      )
                    ))}
                  </tbody>
                </table>

              </div>
              {it_skills.length > 0 && (
                <div className="awards">
                  <div className="section-title">SKILLS</div>
                  <div class="after-underline"></div>
                  <table>
                    {it_skills.slice(0, 15).map((skill, index) => (
                      <tr>
                        <td>
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/16750/16750043.png"
                            alt="tick"
                          />
                        </td>
                        <td><span className="skill-name">{capitalize(skill.it_skill.label)}</span></td>
                      </tr>
                    ))}
                  </table>

                </div>
              )}
            </div>
          </div>
          <div className="right">
            <div className="top">
              {resume_headline && (
                <div className="about">

                  <h2>ABOUT ME</h2>
                  <div class="after-underline"></div>
                  <p>{resume_headline}</p>
                </div>

              )}
            </div>
            <div className="lower">
              {education.length > 0 && (
                <div className="education">
                  <div className="section-title">
                    <div className="img-div">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/46/46955.png"
                        alt="Education Icon"
                      />
                    </div>
                    <h2>EDUCATION</h2>

                  </div>
                  <div class="after-underline"></div>
                  <div className="degree-list">
                    {education.map((edu, index) => (
                      <div className="section-items" key={index}>
                        <div className="years">
                          <p>{edu.passing_year}</p>
                        </div>
                        <div className="company-details">
                          {edu.education_level != "SECONDARY" &&
                            edu.education_level != "SENIOR_SECONDARY" ? (
                            <div>
                              <p className="degree">
                                {edu.jobseeker_degree &&
                                  edu.jobseeker_degree.label}{" "}
                                - {edu.jobseeker_specialization}
                                {/* - {" "} */}
                                {/* {edu.passing_year} */}
                              </p>
                              <p>{edu.board}</p>
                              <p>{
                                performanceScaleOptions.find(
                                  (option) =>
                                    option.value == edu.performance_scale
                                )?.label
                              }{" "}
                                : {edu.performance}</p>
                            </div>
                          ) : (
                            <div>
                              <p className="degree">
                                {
                                  educationLevelsOptions.find(
                                    (option) =>
                                      option.value == edu.education_level
                                  )?.label
                                }{" "}
                                {/* - {edu.passing_year}{" "} */}
                              </p>
                              <p>{edu.board} -{" "}
                                {
                                  schoolMediumsOptions.find(
                                    (option) => option.value == edu.school_medium
                                  )?.label
                                }
                              </p>
                              <p>{
                                performanceScaleOptions.find(
                                  (option) =>
                                    option.value == edu.performance_scale
                                )?.label
                              }{" "}
                                : {edu.performance}</p>
                            </div>
                          )}

                        </div>

                      </div>

                    ))}
                  </div>
                </div>
              )}
              {work_experience.length > 0 && (
                <div className="experience">
                  <div className="section-title">
                    <div className="img-div">
                      <img
                        src="https://icons.veryicon.com/png/o/miscellaneous/zr_icon/work-experience-2.png"
                        alt="Work Experience Icon"
                      />
                    </div>
                    <h2>WORK EXPERIENCE</h2>

                  </div>
                  <div class="after-underline"></div>
                  <div className="degree-list">
                    {work_experience.map((work, index) => (
                      <div className="section-items" key={index}>
                        <div className="years">
                          {formatDate(work.started_working_from)} -{" "}
                          {formatDate(work.worked_till)}
                        </div>
                        <div className="company-details">
                          <p className="degree">
                            {capitalize(work.designation)} @ {work.organization.label}
                          </p>
                          <p>{capitalize(work.job_description)}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {work_sample.length > 0 && (
                <div className="experience">
                  <div className="section-title">
                    <div className="img-div">
                      <img
                        src="https://icons.veryicon.com/png/o/miscellaneous/zr_icon/work-experience-2.png"
                        alt="Work Sample Icon"
                      />
                    </div>
                    <h2>WORK SAMPLES</h2>

                  </div>
                  <div class="after-underline"></div>
                  <div className="degree-list">
                    {work_sample.map((work, index) => (
                      <div key={index} className="section-items">
                        <div className="years">
                          {formatDate(work.work_start)} - {formatDate(work.work_end)}
                        </div>
                        <div className="company-details">
                          <p className="degree">
                            {capitalizeEachWord(work.work_title)}
                          </p>
                          <p><a href={work.work_url}>{work.work_url}</a></p>
                          <p>{capitalize(work.work_description)}</p>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              )}
              {primary_skill.length > 0 && (
                <div className="experience">
                  <div className="section-title">
                    <div className="img-div">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/10262/10262278.png"
                        alt="Main Skills Icon"
                      />
                    </div>
                    <h2>MAIN SKILLS</h2>

                  </div>
                  <div class="after-underline"></div>
                  {/* <ul className="skill-list">
                    {primary_skill.map((skill, index) => (
                      <li key={index}>
                        <p>{skill.label || "Skill Name"}</p>
                        <div className="progress-bar">
                          <div className="progress" style={{ width: `${skill.skill_rating * 10 || 0}%` }}></div>
                        </div>
                      </li>
                    ))}
                  </ul> */}
                  <div className="star-skill-list">
                    {primary_skill.map((skill, index) => (
                      <div className="star-skill" key={index}>
                        <p>{skill.label}</p>
                        <div className="star-container-4">
                          {[...Array(5)].map((_, i) => {
                            let starImage;
                            if (i < Math.floor(skill.skill_rating / 2)) {
                              starImage = star; // Full star
                            } else if (i < Math.ceil(skill.skill_rating / 2)) {
                              starImage = star_half; // Half star
                            } else {
                              starImage = star_blank; // Empty star
                            }
                            return (
                              <img
                                key={i}
                                className="image"
                                src={starImage}
                                alt="star"

                              />
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeTemplate4;